// Initialize deferredPrompt for use later to show browser install prompt.
var deferredPrompt;

function getPWADisplayMode() {
	const isStandalone = window.matchMedia( 'not (display-mode: browser)' ).matches;
	if ( document.referrer.startsWith( 'android-app://' ) ) {
		return 'twa';
	} else if ( navigator.standalone || isStandalone ) {
		return 'standalone';
	}
	return 'browser';
}

window.addEventListener( 'beforeinstallprompt', e => {
	// Prevent the mini-infobar from appearing on mobile.
	e.preventDefault();

	if ( getCookie( 'suppress-pwa-prompt' ) === '1' ) {
		return;
	}

	// Stash the event so it can be triggered later.
	deferredPrompt = e;
	// Update UI notify the user they can install the PWA.
	const prompt = document.querySelector( '.pwa-install-prompt' );
	prompt.hidden = false;
} );

window.addEventListener( 'appinstalled', () => {
	// Hide the app-provided install promotion
	const prompt = document.querySelector( '.pwa-install-prompt' );
	prompt.hidden = true;

	// Clear the deferredPrompt so it can be garbage collected.
	deferredPrompt = null;
} );

window.matchMedia( 'not (display-mode: browser)' ).addEventListener( 'change', evt => {
	let displayMode = 'browser';
	if ( evt.matches ) {
		displayMode = 'standalone';
		const prompt = document.querySelector( '.pwa-install-prompt' );
		prompt.hidden = true;
	}
} );

document.addEventListener( 'DOMContentLoaded', () => {
	const prompt = document.querySelector( '.pwa-install-prompt' );
	const displayMode = getPWADisplayMode();
	if ( displayMode !== 'browser' ) {
		prompt.hidden = true;
		return;
	}

	if ( getCookie( 'suppress-pwa-prompt') === '1' ) {
		prompt.hidden = true;
		return;
	}

	const button = document.querySelector( '#pwa-install-button' );

	button.addEventListener( 'click', async e => {
		if ( ! deferredPrompt ) {
			return;
		}

		e.preventDefault();

		// Show the install prompt.
		deferredPrompt.prompt();
		// Wait for the user to respond to the prompt.
		await deferredPrompt.userChoice;
		// We've used the prompt and can't use it again, throw it away.
		deferredPrompt = null;
	} );

	close_button = document.querySelector( '#pwa-prompt-suppress' );

	close_button.addEventListener( 'click', () => {
		setCookie( 'suppress-pwa-prompt', '1', 30 );
		close_button.parentNode.hidden = true;
	} );
} );

function getCookie( name ) {
	let cookie = {};
	document.cookie.split( ';' ).forEach( el => {
			let [ k,v ] = el.split( '=' );
			cookie[ k.trim() ] = v;
	} );
	return cookie[ name ];
}

function setCookie( name, value, days ) {
	var expires = '';
	if ( days ) {
		var date = new Date();
		date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + ( value || '' ) + expires + '; path=/';
}
